/**
 * Local-only splash preview: /?previewSplash=1
 * Cycles Platform / Source / Function boot shells so design can be judged
 * before shipping. Not linked from production navigation.
 */
import { BrandBootShell } from "@fulcrum5/suite-ui";
import { useCallback, useEffect, useState } from "react";

const PRODUCTS = ["Platform", "Source", "Function"] as const;

export function SplashPreview(): JSX.Element {
  const [index, setIndex] = useState(0);
  const [ready, setReady] = useState(false);
  const [key, setKey] = useState(0);
  const product = PRODUCTS[index]!;

  const replay = useCallback((nextIndex: number) => {
    setIndex(nextIndex);
    setReady(false);
    setKey((k) => k + 1);
  }, []);

  // Hold ~1.6s (enter + hold bar), then release so you see the exit crossfade.
  useEffect(() => {
    const t = window.setTimeout(() => setReady(true), 1600);
    return () => window.clearTimeout(t);
  }, [key]);

  return (
    <div style={{ minHeight: "100vh", background: "#F0F2F5" }}>
      <BrandBootShell
        key={key}
        holdLabel={`Opening ${product}`}
        productName={product}
        ready={ready}
      >
        <div
          style={{
            minHeight: "100vh",
            display: "grid",
            placeItems: "center",
            padding: 24,
            fontFamily: "Outfit, Inter, system-ui, sans-serif",
            color: "#1A3A6B",
          }}
        >
          <div style={{ textAlign: "center", maxWidth: 420 }}>
            <p style={{ margin: "0 0 8px", letterSpacing: "0.14em", textTransform: "uppercase", fontSize: 12, fontWeight: 600, color: "#565E72" }}>
              Preview complete
            </p>
            <h1 style={{ margin: "0 0 12px", fontSize: 28, fontWeight: 700 }}>{product}</h1>
            <p style={{ margin: "0 0 20px", color: "#3D4456", lineHeight: 1.5 }}>
              Splash finished. Pick a product to replay the boot banner.
            </p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center" }}>
              {PRODUCTS.map((name, i) => (
                <button
                  key={name}
                  type="button"
                  onClick={() => replay(i)}
                  style={{
                    minHeight: 40,
                    padding: "0 16px",
                    borderRadius: 999,
                    border: "1px solid #C8CED8",
                    background: i === index ? "#1A3A6B" : "#fff",
                    color: i === index ? "#fff" : "#1A3A6B",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  Replay {name}
                </button>
              ))}
            </div>
            <p style={{ marginTop: 24, fontSize: 13, color: "#565E72" }}>
              Local only — open <code>?previewSplash=1</code>. Not production navigation.
            </p>
          </div>
        </div>
      </BrandBootShell>
    </div>
  );
}
